var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, cancel, fork, put, take, takeEvery } from "redux-saga/effects";
import logger from "../../logger";
import { getContactForAccountId } from "../../redux/contact/contact.saga";
import { showAlert } from "../../utils/alert/alert.utils";
import { getMessageForError } from "../../utils/error.utils";
import { getGeneralCreateSuccessText, getLocalizedText, } from "../../utils/i18n/i18n.utils";
import { generateSaga } from "../generators/generator.saga";
import { removeBankAccountStart, removeBankAccountSucceeded, removeBankAccountFailed, updateBankAccountOwnerNameStart, updateBankAccountOwnerNameSucceeded, updateBankAccountOwnerNameFailed, getContactBankAccountsStart, getContactBankAccountsSucceeded, getContactBankAccountsFailed, createContactBankAccountStart, createContactBankAccountSucceeded, createContactBankAccountFailed, } from "./bankAccount.actions";
import * as bankAccountApi from "./bankAccount.api";
import { GENERATOR_PARAMS } from "./bankAccount.constants";
import { getContactBankAccountsKey } from "./bankAccount.utils";
function removeBankAccountStartFlow(action) {
    var _a, id, onSuccess, onFailure, response, unknownError_1, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, id = _a.id, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(bankAccountApi.removeBankAccount, id)];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, put(removeBankAccountSucceeded.getAction({
                        id: id,
                        result: response.data,
                    }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data);
                showAlert({
                    type: "success",
                    message: getLocalizedText("contact.remove_bank_account.success"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_1 = _b.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(removeBankAccountFailed.getAction({
                        id: id,
                        error: error,
                    }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                showAlert({
                    type: "error",
                    // `rawException` is only filled in when the API runs with debug logging,
                    // so reading it meant production only ever showed a generic fallback.
                    // getMessageForError reads the field the API actually sends and falls
                    // back to a safe localized message when there is nothing to show.
                    message: getMessageForError(unknownError_1),
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function updateBankAccountOwnerNameStartFlow(action) {
    var _a, id, data, onSuccess, onFailure, response, bankAccount, unknownError_2, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, id = _a.id, data = _a.data, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(bankAccountApi.updateBankAccountOwnerName, id, data)];
            case 2:
                response = _b.sent();
                bankAccount = response.data.data;
                return [4 /*yield*/, put(updateBankAccountOwnerNameSucceeded.getAction({
                        id: id,
                        result: bankAccount,
                    }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(bankAccount);
                showAlert({
                    type: "success",
                    message: getLocalizedText("bank_account.edit_owner_name.success"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_2 = _b.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                return [4 /*yield*/, put(updateBankAccountOwnerNameFailed.getAction({
                        id: id,
                        error: error,
                    }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                showAlert({
                    type: "error",
                    // `rawException` is only filled in when the API runs with debug logging,
                    // so reading it meant production only ever showed a generic fallback.
                    // getMessageForError reads the field the API actually sends and falls
                    // back to a safe localized message when there is nothing to show.
                    message: getMessageForError(unknownError_2),
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
/**
 * The contact a bank account list belongs to. A caller that already knows the
 * contact is taken at its word; one that only knows the account has to resolve
 * it first, because the API route is keyed on the contact.
 */
function resolveContactId(_a) {
    var contact;
    var contactId = _a.contactId, accountId = _a.accountId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (contactId != null) {
                    return [2 /*return*/, contactId];
                }
                if (accountId == null) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(getContactForAccountId, accountId)];
            case 1:
                contact = _b.sent();
                return [2 /*return*/, contact === null || contact === void 0 ? void 0 : contact.id];
        }
    });
}
function getContactBankAccountsStartFlow(action) {
    var _a, contactId, accountId, resolvedContactId, response, unknownError_3, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, contactId = _a.contactId, accountId = _a.accountId;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(resolveContactId, {
                        contactId: contactId,
                        accountId: accountId,
                    })];
            case 2:
                resolvedContactId = _b.sent();
                if (resolvedContactId == null) {
                    throw new Error("No contact");
                }
                return [4 /*yield*/, call(bankAccountApi.getBankAccountsForContact, resolvedContactId)];
            case 3:
                response = _b.sent();
                return [4 /*yield*/, put(getContactBankAccountsSucceeded.getAction({
                        contactId: contactId,
                        accountId: accountId,
                        result: response.data,
                    }))];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                unknownError_3 = _b.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                return [4 /*yield*/, put(getContactBankAccountsFailed.getAction({ contactId: contactId, accountId: accountId, error: error }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
/**
 * `takeLatest` would cancel whichever fetch is in flight, no matter which list it
 * is for, while this cache holds one entry per contact (or per account). Two
 * screens asking for two different lists in the same render - the contact edit
 * modal asks by account id while its financial tab asks by contact id - would
 * then leave the cancelled entry pending forever, and its list empty. Cancelling
 * per key keeps "the latest request for this list wins" without touching the
 * others.
 */
export function watchGetContactBankAccounts() {
    var runningByKey, _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                runningByKey = {};
                _loop_1 = function () {
                    var action, key, running, task, settledKey_1, forget;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, take(getContactBankAccountsStart.type)];
                            case 1:
                                action = _b.sent();
                                key = getContactBankAccountsKey(action.payload);
                                running = key ? runningByKey[key] : undefined;
                                if (!running) return [3 /*break*/, 3];
                                return [4 /*yield*/, cancel(running)];
                            case 2:
                                _b.sent();
                                _b.label = 3;
                            case 3: return [4 /*yield*/, fork(getContactBankAccountsStartFlow, action)];
                            case 4:
                                task = _b.sent();
                                if (key) {
                                    settledKey_1 = key;
                                    runningByKey[settledKey_1] = task;
                                    forget = function () {
                                        if (runningByKey[settledKey_1] === task) {
                                            delete runningByKey[settledKey_1];
                                        }
                                    };
                                    task.toPromise().then(forget, forget);
                                }
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
function createContactBankAccountStartFlow(action) {
    var _a, contactId, accountId, data, onSuccess, onFailure, resolvedContactId, response, bankAccount, unknownError_4, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, contactId = _a.contactId, accountId = _a.accountId, data = _a.data, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(resolveContactId, {
                        contactId: contactId,
                        accountId: accountId,
                    })];
            case 2:
                resolvedContactId = _b.sent();
                if (resolvedContactId == null) {
                    throw new Error("No contact");
                }
                return [4 /*yield*/, call(bankAccountApi.createBankAccountForContact, {
                        contactId: resolvedContactId,
                        data: data,
                    })];
            case 3:
                response = _b.sent();
                bankAccount = response.data;
                return [4 /*yield*/, put(createContactBankAccountSucceeded.getAction({
                        contactId: contactId,
                        accountId: accountId,
                        result: bankAccount,
                    }))];
            case 4:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(bankAccount.id);
                showAlert({
                    type: "success",
                    message: getGeneralCreateSuccessText("iban"),
                });
                return [3 /*break*/, 7];
            case 5:
                unknownError_4 = _b.sent();
                error = unknownError_4;
                logger.logError({ error: error });
                return [4 /*yield*/, put(createContactBankAccountFailed.getAction({ error: error }))];
            case 6:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(removeBankAccountStart.type, removeBankAccountStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(updateBankAccountOwnerNameStart.type, updateBankAccountOwnerNameStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, fork(watchGetContactBankAccounts)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(createContactBankAccountStart.type, createContactBankAccountStartFlow)];
            case 4:
                _a.sent();
                return [4 /*yield*/, generateSaga(GENERATOR_PARAMS)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
